/* eslint @typescript-eslint/no-var-requires: "off" */
export const environment = {
  production: true,
  apiUrl: '/webapi/',
  demo:true,
  homeUrl: '/',
  KYCUrl: 'https://kycstg.nicolawealth.com/#/client-validate?acessToken=',
  mobileAppShowLinks  : false,
  mobileAppAndroidLink: 'https://play.google.com/store/apps/details?id=com.nicolawealth.nicola',
  mobileAppIphoneLink : 'https://apps.apple.com/ca/app/nicola/id1467423591',
  legalPageLink: 'https://www.nicolawealth.com/legal/',
  privacyPageLink: 'https://www.nicolawealth.com/legal#canadian-privacy-policy',
  demoSite: false,
  appVersion: require('../../package.json').version + '-stg',
  msOAuth: 'https://nw-ms-login-stg.azurewebsites.net/api/o365?code=KjE-_gT4l7W5D9lKTu7LKwlNHqkxxIr1BAbhc3N016zKAzFueGsyxA==',
  sentry: {
    dsn: 'https://d1dfcda8db4d491b975fbd238a76003c@o1262277.ingest.sentry.io/6591649',
    debug: 'true',
    tracesSampleRate: '0.01',
    sendUserData: 'true',
  },
  build: {
    env: 'stg',
    number: 'clweb@20260625.4',
  }
};
